import { render, staticRenderFns } from "./IsArticlePendingModal.vue?vue&type=template&id=0808bb62&scoped=true"
import script from "./IsArticlePendingModal.vue?vue&type=script&lang=js"
export * from "./IsArticlePendingModal.vue?vue&type=script&lang=js"
import style0 from "./IsArticlePendingModal.vue?vue&type=style&index=0&id=0808bb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808bb62",
  null
  
)

export default component.exports